import React from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, UsersIcon, WalletIcon, WrenchIcon, FileCheckIcon } from 'lucide-react';
export function About() {
  const useCases = [{
    icon: PackageIcon,
    title: 'Secure Inventory',
    description: 'Grab stock before your competitor does.'
  }, {
    icon: UsersIcon,
    title: 'Scale Your Team',
    description: "Hire the talent who'll 10x your output."
  }, {
    icon: WalletIcon,
    title: 'Bridge Cash Flow',
    description: 'Cover payroll while waiting on receivables.'
  }, {
    icon: WrenchIcon,
    title: 'Upgrade Equipment',
    description: "Replace the gear that's holding you back."
  }, {
    icon: FileCheckIcon,
    title: 'Seize Contracts',
    description: 'Say YES to the deal sitting on your desk.'
  }];
  return <section id="about" className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="max-w-5xl mx-auto" data-id="element-27">
          <div className="mb-12" data-id="element-28">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-29">
              Your Business Deserves Funding
            </h2>
            <p className="text-lg text-zinc-300 max-w-3xl" data-id="element-30">
              You're running a real business. Doing real revenue. Managing real
              cash flow. And you need capital to grow.
            </p>
          </div>

          {/* Interactive Use Cases Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-31">
            {useCases.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255,255,255,0.2)'
          }} className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800 backdrop-blur-sm hover:bg-zinc-900 transition-colors group cursor-default" data-id="element-32">
                <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center mb-4 border border-zinc-800 group-hover:border-zinc-700 transition-colors" data-id="element-33">
                  <item.icon className="w-6 h-6 text-white" data-id="element-34" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-35">
                  {item.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-36">
                  {item.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}